import store from "../store";

export default async function guest({ next }) {

  if (store.getters["auth/isAuthenticated"]) {
    // If user is authenticated, fetch profile and redirect to first menu
    await store.dispatch("profile/me");
    let userProfile = store.getters["profile/me"];
    let firstMenu = userProfile.data?.menu[0]?.nombre || false;
    if (!firstMenu) {
      try {
        await store.dispatch("auth/logout");
      } finally {
        // eslint-disable-next-line no-unsafe-finally
        return next({ name: "Login" });
      }
    }
    return next({ name: firstMenu });
  }

  next();
}
